
import { DELETE_PARAM, DELETE_PARAM_SUCCESS, DELETE_PARAM_ERROR} from './actionTypes';

const initialState = {
    errorDeletePARAM: "",
    loadingDeletePARAM: false,
    param: null,
    successDeletePARAM: ""
}

const deletePARAM = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_PARAM:
            state = {
                ...state,
                loadingDeletePARAM: true
            }
            break;
        case DELETE_PARAM_SUCCESS:
            state = {
                ...state,
                loadingDeletePARAM: false,
                param: action.payload.param, 
                successDeletePARAM: action.payload.message
            }
            break;
        case DELETE_PARAM_ERROR:
            state = { ...state, errorDeletePARAM: action.payload, loadingDeletePARAM: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default deletePARAM;